//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import config from '../../config';

//-- Custom
import { withStyles } from "@material-ui/core/styles";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import { TaxActions, alertActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';


//-- CSS for Material
const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
});

class TaxSetting extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            deleteOpen: false,
            taxSettingAdd: false,
            addingError: '',
            enableAdding: false,
            allTaxSettings: false,
            perPage: config.perPageData,
            editingTaxData: false,
            enableediting: false,
            enableDelete: false,
            deleteSent: false,
            countryCodes : ["AS","AF","AL","DZ","AD","AO","AI","AQ","AG","AR","AM","AW","AU","AT","AZ","BS","BH","BD","BB","BY","BE","BZ","BJ","BM","BT","BO","BQ","BA","BW","BV","BR","IO","BN","BG","BF","BI","CV","KH","CM","CA","KY","CF","TD","CL","CN","CX","CC","CO","KM","CD","CG","CK","CR","HR","CU","CW","CY","CZ","CI","DK","DJ","DM","DO","EC","EG","SV","GQ","ER","EE","SZ","ET","FK","FO","FJ","FI","FR","GF","PF","TF","GA","GM","GE","DE","GH","GI","GR","GL","GD","GP","GU","GT","GG","GN","GW","GY","HT","HM","VA","HN","HK","HU","IS","IN","ID","IR","IQ","IE","IM","IL","IT","JM","JP","JE","JO","KZ","KE","KI","KP","KR","KW","KG","LA","LV","LB","LS","LR","LY","LI","LT","LU","MO","MG","MW","MY","MV","ML","MT","MH","MQ","MR","MU","YT","MX","FM","MD","MC","MN","ME","MS","MA","MZ","MM","NA","NR","NP","NL","NC","NZ","NI","NE","NG","NU","NF","MP","NO","OM","PK","PW","PS","PA","PG","PY","PE","PH","PN","PL","PT","PR","QA","MK","RO","RU","RW","RE","BL","SH","KN","LC","MF","PM","VC","WS","SM","ST","SA","SN","RS","SC","SL","SG","SX","SK","SI","SB","SO","ZA","GS","SS","ES","LK","SD","SR","SJ","SE","CH","SY","TW","TJ","TZ","TH","TL","TG","TK","TO","TT","TN","TR","TM","TC","TV","UG","UA","AE","GB","UM","US","UY","UZ","VU","VE","VN","VG","VI","WF","EH","YE","ZM","ZW","AX"]
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;


        dispatch(TaxActions.getTaxSettings(apiConstants.GET_ALL_TAX_SETTINGS, postData));
    }



    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {

        const { dispatch } = props;
        const { siteConstants } = props.language;
        //check if category already exist with same name Or get-success
        if (
            props.addTaxSettings !== undefined &&
            props.addTaxSettings.taxAdd !== undefined &&
            props.addTaxSettings.taxAdd.data !== undefined &&
            props.addTaxSettings.taxAdd.data.success === false
        ) {
            if (this.state.enableAdding === true) {
                this.setState({ addingError: 'country already exists ! Try different one!', enableAdding: false });
            }


        } else if (
            props.addTaxSettings !== undefined &&
            props.addTaxSettings.taxAdd !== undefined &&
            props.addTaxSettings.taxAdd.data !== undefined &&
            props.addTaxSettings.taxAdd.data.success === true
        ) {
            if (this.state.enableAdding === true) {
                this.setState({ taxSettingAdd: false, enableAdding: false, addingError: '' });
                dispatch(alertActions.success('country added successfully'));

                // get new data from collection to refresh
                let postData = {};
                postData.page = 1;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;
                dispatch(TaxActions.getTaxSettings(apiConstants.GET_ALL_TAX_SETTINGS, postData));

                setTimeout(function () {
                    dispatch(alertActions.clear());
                }, 3000);
            }
        }


        // get all the tax settings from collection
        if (
            props.getTaxSettings !== undefined &&
            props.getTaxSettings.taxGet !== undefined &&
            props.getTaxSettings.taxGet.data !== undefined &&
            props.getTaxSettings.taxGet.data.data !== undefined
        ) {
            const taxDataReceived = props.getTaxSettings.taxGet.data;

            this.setState({
                allTaxSettings: taxDataReceived,
                totalPage: taxDataReceived.pagination.totalPages,
                totalDataCount: taxDataReceived.pagination.totalCount,
            })

        }

        // this props work after editing a tax setting
        if (
            props.editTaxSettings !== undefined &&
            props.editTaxSettings.taxedit !== undefined &&
            props.editTaxSettings.taxedit.data !== undefined &&
            props.editTaxSettings.taxedit.data.success === false
        ) {
            if (this.state.enableediting === true) {
                this.setState({ addingError: 'country already exists ! Try different one!', enableediting: false });
            }


        } else if (
            props.editTaxSettings !== undefined &&
            props.editTaxSettings.taxedit !== undefined &&
            props.editTaxSettings.taxedit.data !== undefined &&
            props.editTaxSettings.taxedit.data.success === true
        ) {
            if (this.state.enableediting === true) {
                this.setState({ editingTaxData: false, enableediting: false, addingError: '' });
                dispatch(alertActions.success('country updated added successfully'));

                // get new data from collection to refresh
                let postData = {};
                postData.page = 1;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;
                dispatch(TaxActions.getTaxSettings(apiConstants.GET_ALL_TAX_SETTINGS, postData));

                setTimeout(function () {
                    dispatch(alertActions.clear());
                }, 3000);
            }
        }

        // when deleting a data
        if (
            props.deleteTaxSettings !== undefined &&
            props.deleteTaxSettings.taxDelete !== undefined &&
            props.deleteTaxSettings.taxDelete.data !== undefined &&
            props.deleteTaxSettings.taxDelete.data.success === true
        ) {
            if (this.state.deleteSent === true) {
                this.setState({ enableDelete: false, deleteTaxId: false, deleteSent: false })
                dispatch(alertActions.success(siteConstants.GEN_TAX_DELETED));

                // get new data from collection to refresh
                let postData = {};
                postData.page = 1;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;
                dispatch(TaxActions.getTaxSettings(apiConstants.GET_ALL_TAX_SETTINGS, postData));

            }
            setTimeout(function () {
                dispatch(alertActions.clear());
            }, 3000);

        }



    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(TaxActions.getTaxSettings(apiConstants.GET_ALL_TAX_SETTINGS, postData));
    }

    // hit api and get category data for selected list range
    changeTableData = (e) => {
        const { dispatch } = this.props;
        this.setState({ perPage: e.target.value })

        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);

        dispatch(TaxActions.getTaxSettings(apiConstants.GET_ALL_TAX_SETTINGS, postData));
    }

    /*
    * searchTaxList - User can search data from the database and it will appear
    */
    searchTaxList(keyword) {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(TaxActions.getTaxSettings(apiConstants.SEARCH_TAX_SETTINGS, postData));
        } else {
            dispatch(TaxActions.getTaxSettings(apiConstants.GET_ALL_TAX_SETTINGS, postData));
        }
    }

    //close add tax popup
    closeAddTaxPop = () => {
        this.setState({
            taxSettingAdd: false,
            addingError: ''
        })
    }

    //save to tax collection to collection
    handleSubmit = () => {
        const { dispatch } = this.props;
        const { siteConstants } = this.props.language;
        const { taxCountry, taxCountryCode, taxName, taxType, taxValue, taxStatus } = this.state;
        if (taxCountry === undefined || taxCountry === '') { this.setState({ addingError: siteConstants.LABEL_TAX_COUNTRY_PLACEHOLDER + ' is required!!' }) }
        else if (taxName === undefined || taxName === '') { this.setState({ addingError: 'Tax Name is required!!' }) }
        else if (taxCountryCode === undefined || taxCountryCode === '') { this.setState({ addingError: siteConstants.LABEL_TAX_COUNTRY_CODE_PLACEHOLDER_RQR + ' is required!!' }) }
        else if (taxValue === undefined || taxValue === '') { this.setState({ addingError: siteConstants.LABEL_TAX_VALUE_PLACEHOLDER + ' is required!!' }) }
        else if (taxType === undefined || taxType === '' || taxType === '---') { this.setState({ addingError: siteConstants.LABEL_TAX_TYPE_PLACEHOLDER + ' is required!!' }) }
        else if (taxStatus === undefined || taxStatus === '' || taxStatus === '---') { this.setState({ addingError: siteConstants.LABEL_TAX_STATUS_PLACEHOLDER + ' is required!!' }) }
        else {
            this.setState({ enableAdding: true });
            const postData = {};
            postData.taxCountry = taxCountry;
            postData.taxName = taxName;
            postData.taxCountryCode = taxCountryCode;
            postData.taxType = taxType;
            postData.taxValue = taxValue;
            postData.taxStatus = taxStatus;

            dispatch(TaxActions.saveTaxSettings(apiConstants.SAVE_TAX_SETTINGS, postData));
        }



    }

    // edit handle for tax settigns
    handleSubmitEdit = () => {
        const { dispatch } = this.props;
        const { editingTaxId, editingCountryName,editingTaxName,  editingCountryCode, editingTaxType, editingTaxValue, editingTaxStatus } = this.state;
        const { siteConstants } = this.props.language;


        if (editingCountryName === undefined || editingCountryName === '') { this.setState({ addingError: siteConstants.LABEL_TAX_COUNTRY_PLACEHOLDER + ' is required!!' }) }
        else if (editingCountryCode === undefined || editingCountryCode === '') { this.setState({ addingError: siteConstants.LABEL_TAX_COUNTRY_CODE_PLACEHOLDER_RQR + ' is required!!' }) }
        else if (editingTaxName === undefined || editingTaxName === '') { this.setState({ addingError: 'Tax Name is required!!' }) }
        else if (editingTaxValue === undefined || editingTaxValue === '') { this.setState({ addingError: siteConstants.LABEL_TAX_VALUE_PLACEHOLDER + ' is required!!' }) }
        else if (editingTaxType === undefined || editingTaxType === '' || editingTaxType === '---') { this.setState({ addingError: siteConstants.LABEL_TAX_TYPE_PLACEHOLDER + ' is required!!' }) }
        else if (editingTaxStatus === undefined || editingTaxStatus === '' || editingTaxStatus === '---') { this.setState({ addingError: siteConstants.LABEL_TAX_STATUS_PLACEHOLDER + ' is required!!' }) }
        else {
            this.setState({ enableediting: true });
            const postData = {};
            postData.id = editingTaxId;
            postData.taxCountry = editingCountryName;
            postData.taxCountryCode = editingCountryCode;
            postData.taxName = editingTaxName;
            postData.taxType = editingTaxType;
            postData.taxValue = editingTaxValue;
            postData.taxStatus = editingTaxStatus;

            dispatch(TaxActions.editTaxSettings(apiConstants.EDIT_TAX_SETTINGS, postData));
        }


    }


    // popup for editing the category state hold
    editTaxSettings = (taxdata) => {
        this.setState({
            editingTaxData: true,
            editingTaxId: taxdata._id,
            editingCountryName: taxdata.countryName,
            editingTaxName : taxdata.taxName,
            editingCountryCode: taxdata.countryCode,
            editingTaxType: taxdata.taxType,
            editingTaxValue: taxdata.taxValue,
            editingTaxStatus: taxdata.status,
        });
    }

    //close the pop for edit
    closeEditTaxPop = () => {
        this.setState({ editingTaxData: false, addingError: '' });
    }

    // popup close and handle functions
    openAddTaxSetting = () => { this.setState({ taxSettingAdd: !this.state.taxSettingAdd }); }
    handleClose = () => { this.setState({ taxSettingAdd: !this.state.taxSettingAdd, addingError: '' }) };
    onChangeHandleField = (e) => { this.setState({ [e.target.name]: e.target.value }); }

    // delete tax record functions
    DeletePopupOpen = (taxId) => { this.setState({ enableDelete: true, deleteTaxId: taxId }) }
    closeDeletePopup = () => { this.setState({ enableDelete: false, deleteTaxId: false }) }
    deletingTaxRecord = () => {
        const { dispatch } = this.props;
        if (this.state.deleteTaxId) {
            this.setState({ deleteSent: true, })
            let postData = {};
            postData.taxid = this.state.deleteTaxId;

            dispatch(TaxActions.deleteTaxSettings(apiConstants.DELETE_TAX_SETTINGS, postData));
        }
    }
    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { classes } = this.props;

        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/settings">{siteConstants.MENU_SETTINGS}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_TAX_SETTING}
                                </li>
                                <li style={{ paddingLeft: "700px" }}>
                                    <a href="/settings" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <div>
                                    <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_TAX_SETTING}</h1>
                                    <p>{siteConstants.MENU_TAX_SETTING_DESCRIPTION}</p>
                                </div>
                                <a href="javascript:void(0)"
                                    onClick={() => this.openAddTaxSetting()}
                                >
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" placeholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchTaxList(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="col">{siteConstants.LABEL_TAX_COUNTRY_PLACEHOLDER}</th>
                                                    <th scope="col">{siteConstants.LABEL_TAX_COUNTRY_CODE_PLACEHOLDER_RQR}</th>
                                                    <th scope="col">{siteConstants.GEN_NAME}</th>
                                                    <th width="col">{siteConstants.LABEL_TAX_TYPE_PLACEHOLDER}</th>
                                                    <th width="col">{siteConstants.LABEL_TAX_VALUE_PLACEHOLDER}</th>
                                                    <th width="col">{siteConstants.LABEL_TAX_STATUS_PLACEHOLDER}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.allTaxSettings.data != undefined &&
                                                        this.state.allTaxSettings.data.length > 0 ?
                                                        this.state.allTaxSettings.data.map((thisTax, index) => {
                                                            let stText = 'Active';
                                                            if (thisTax.status === 0) { stText = 'Deactive'; }

                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{thisTax.countryName}</td>
                                                                    <td>{thisTax.countryCode}</td>
                                                                    <td>{thisTax.countryName}</td>
                                                                    <td>{thisTax.taxType}</td>
                                                                    <td>{thisTax.taxValue}</td>
                                                                    <td>{stText}</td>
                                                                    <td className="tdTextCenter">
                                                                        <a
                                                                            className="actionIcon"
                                                                            title="Edit"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.editTaxSettings(thisTax)}
                                                                        ><span><img src="assets/img/svg/EditIcon.png" alt="Edit" /></span>
                                                                        </a>
                                                                        <a className="actionIcon"
                                                                            title="Delete"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.DeletePopupOpen(thisTax._id)}
                                                                        ><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="8" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage}  funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add category popup */}
                    <Dialog
                        open={this.state.taxSettingAdd}
                        aria-labelledby="category-title"
                        aria-describedby="save-category-description"
                        fullWidth="true"
                    >
                        <DialogTitle className={classes.root}>{siteConstants.LABEL_POPUP_TAX_ADD}</DialogTitle>
                        <DialogContent>
                            <div class="row">
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_TAX_COUNTRY}</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_TAX_COUNTRY_PLACEHOLDER}
                                            className="form-control"
                                            name="taxCountry"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_TAX_COUNTRY_CODE}</label>
                                        {/*<input
                                            type="text"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_TAX_COUNTRY_CODE_PLACEHOLDER}
                                            className="form-control"
                                            name="taxCountryCode"
                                        />*/}

                                        <select  className="form-control" name="taxCountryCode" onChange={(e) => this.onChangeHandleField(e)}>
                                        {
                                          this.state.countryCodes && this.state.countryCodes.map( (data) => {
                                            return (<option>{data}</option>)
                                          })
                                        }
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.GEN_NAME}(*)</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.GEN_NAME}
                                            className="form-control"
                                            name="taxName"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_TAX_VALUE}</label>
                                        <input
                                            type="number"
                                            min="1"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_TAX_VALUE_PLACEHOLDER}
                                            className="form-control"
                                            name="taxValue"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_TAX_TYPE}</label>
                                        <select
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            className="form-control"
                                            name="taxType"
                                        >
                                            <option>---</option>
                                            <option value="flat">Flat</option>
                                            <option value="percentage">Percentage</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_TAX_STATUS}</label>
                                        <select
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            className="form-control"
                                            name="taxStatus"
                                        >
                                            <option value="1">---</option>
                                            <option value="1">Active</option>
                                            <option value="0">Deactive</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <p style={{ color: 'red' }}>{this.state.addingError}</p>
                                    </div>
                                </div>

                            </div>
                        </DialogContent>


                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmit(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeAddTaxPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* edit category popup */}
                    <Dialog
                        open={this.state.editingTaxData}
                        aria-labelledby="category-title"
                        aria-describedby="save-category-description"
                        fullWidth="true"
                    >
                        <DialogTitle className={classes.root}>{siteConstants.LABEL_POPUP_TAX_UPDATE}</DialogTitle>
                        <DialogContent>
                            <div class="row">
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_TAX_COUNTRY}</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_TAX_COUNTRY_PLACEHOLDER}
                                            className="form-control"
                                            name="editingCountryName"
                                            value={this.state.editingCountryName}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_TAX_COUNTRY_CODE}</label>
                                        {/*<input
                                            type="text"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_TAX_COUNTRY_CODE_PLACEHOLDER}
                                            className="form-control"
                                            name="editingCountryCode"
                                            value={this.state.editingCountryCode}

                                        />*/}
                                        <select  className="form-control" name="editingCountryCode" onChange={(e) => this.onChangeHandleField(e)} value={this.state.editingCountryCode}>
                                        {
                                          this.state.countryCodes && this.state.countryCodes.map( (data) => {
                                            return (<option>{data}</option>)
                                          })
                                        }
                                        </select>

                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.GEN_NAME}</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.GEN_NAME}
                                            className="form-control"
                                            name="editingTaxName"
                                            value={this.state.editingTaxName}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_TAX_VALUE}</label>
                                        <input
                                            type="number"
                                            min="1"
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            placeholder={siteConstants.LABEL_TAX_VALUE_PLACEHOLDER}
                                            className="form-control"
                                            name="editingTaxValue"
                                            value={this.state.editingTaxValue}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_TAX_TYPE}</label>
                                        <select
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            className="form-control"
                                            name="editingTaxType"
                                            defaultValue={this.state.editingTaxType}
                                        >
                                            <option>---</option>
                                            <option value="flat">Flat</option>
                                            <option value="percentage">Percentage</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_TAX_STATUS}</label>
                                        <select
                                            onChange={(e) => this.onChangeHandleField(e)}
                                            className="form-control"
                                            name="editingTaxStatus"
                                            defaultValue={this.state.editingTaxStatus}
                                        >
                                            <option>---</option>
                                            <option value="1">Active</option>
                                            <option value="0">Deactive</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <p style={{ color: 'red' }}>{this.state.addingError}</p>
                                    </div>
                                </div>

                            </div>
                        </DialogContent>


                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmitEdit(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeEditTaxPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>

                    {/* notify about delete */}
                    <Dialog open={this.state.enableDelete} aria-labelledby="delete-tax-notify" >
                        <DialogTitle className={classes.root}>
                            {siteConstants.BTN_DELETE}
                        </DialogTitle>
                        <DialogContent>
                            {siteConstants.LABEL_SURE_DELTE_TAX_RECORD}
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.deletingTaxRecord(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>


                    <Footer />
                </div>



            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, addTaxSettings, getTaxSettings, editTaxSettings, deleteTaxSettings } = state;
    return {
        language,
        addTaxSettings,
        getTaxSettings,
        editTaxSettings,
        deleteTaxSettings
    };
}


export default connect(mapStateToProps)(withStyles(styles)(TaxSetting))
